import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import FAQSectionComponent from './FAQSectionComponent'

import { getCustomBlock } from 'app/components/CustomBlocks'
import Blocks from 'app/helpers/Blocks'

export interface IAttributes {
  title: string
  footer: string
}

const EstimatorFactorsSectionBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <FAQSectionComponent
      {...attributes}
      innerBlocks={<Blocks blocks={props.innerBlocks} mapToBlock={getCustomBlock} />}
    />
  )
}

export default EstimatorFactorsSectionBlock
